import React from 'react';

const FileDownload = ({
  color = '#3B8088',
  size = '20'
}: {
  size?: string | number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.834 17.5H14.1673C15.548 17.5 16.6673 16.3807 16.6673 15V7.09109C16.6673 6.42805 16.4039 5.79217 15.9351 5.32333L13.844 3.23223C13.3751 2.76339 12.7393 2.5 12.0762 2.5H5.83398C4.45327 2.5 3.33398 3.61929 3.33398 5V10.8333M16.6673 7.08333H13.7507C12.8302 7.08333 12.084 6.33714 12.084 5.41667V2.5M5.83398 13.3333V17.5M5.83398 17.5L7.50065 15.8333M5.83398 17.5L4.16732 15.8333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileDownload;
